import React from 'react';
import { X } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhyItFailed() {
  const failures = ["Traditional planners assume you have 100% capacity, leaving you feeling guilty when you can't finish the list.", '"Self-care" routines like bubble baths and face masks don\'t solve the underlying dread of a 9 AM meeting.', '"Muscling through" only spikes your cortisol, leading to the 2 AM wake-up call where your brain audits your entire life.', "Pre-working on Sunday night doesn't get you ahead; it just robs you of your only rest."];
  return <section className="bg-cream py-20 md:py-28 px-6" data-id="element-192">
      <div className="max-w-reading mx-auto" data-id="element-193">
        <FadeIn data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-serif text-forest mb-12 text-center" data-id="element-195">
            Why what you tried didn't work
          </h2>
          <div className="space-y-8" data-id="element-196">
            {failures.map((text, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-197">
                <div className="flex items-start gap-4" data-id="element-198">
                  <div className="mt-1.5 flex-shrink-0" data-id="element-199">
                    <X className="w-6 h-6 text-red-400/80" strokeWidth={2.5} data-id="element-200" />
                  </div>
                  <p className="text-lg text-charcoal/90 font-light leading-relaxed" data-id="element-201">
                    {text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}